export const bolepidemiologicos2025DAN = [
  {
    "etiqueta_elemento": "1er Informe Trimestral 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/DAN/1er Informe Trimestral 2025 Defectos al Nacimiento.pdf",
  },
  {
    "etiqueta_elemento": "2o Informe Trimestral 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/DAN/2o Informe Trimestral 2025 Defectos al Nacimiento.pdf",
  },
  {
    "etiqueta_elemento": "3er Informe Trimestral 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/DAN/3er Informe Trimestral 2025 Defectos al Nacimiento.pdf",
  },
  {
    "etiqueta_elemento": "4o Informe Trimestral 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/DAN/4o Informe Trimestral 2025 Defectos al Nacimiento.pdf",
  },
]